<template>
  <el-dialog
    title="切换模式"
    width="920px"
    :visible.sync="dialogVisible"
    @close="$emit('update:visible',false)"
  >
    <div class="dialog_conwrap">
      <div class="module_wrap">
        <div
          class="module_item"
          v-for="(modelitem,index) in modellist"
          :key="index"
          :class="{active_item:currentid===modelitem.id}"
          @click="choosemodel(modelitem)"
        >
          <img :src="modelitem.pic" alt srcset />
          <div class="module_info">{{modelitem.name}}</div>
          <p class="module_intr">{{modelitem.desct}}</p>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="save()">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import api from "@/api.js";
export default {
  name: "chooseModuleDialog",
  props: ["visible", "modellist", "id"],
  watch: {
    visible() {
      this.dialogVisible = this.visible;
    }
  },
  data() {
    return {
      currentid: this.id,
      dialogVisible: this.visible
    };
  },
  created() {},
  methods: {
    // 选择模式
    choosemodel(modelitem) {
      this.currentid = modelitem.id;
    },

    // 保存
    save(formName) {
      if (this.currentid === "") {
        this.$message({
          message: "请选择模式",
          type: "warning"
        });
      } else {
        let params = {
          decorate: this.currentid
        };
        this.axios
          .post(api.decorate_edit, params)
          .then(response => {
            if (response.data.code == 0) {
              this.$message({
                message: "保存成功",
              });
              this.$emit("choosemodelesucess");
              this.dialogVisible = false;
            } else {
            }
          })
          .catch(() => {});
      }
    }
  }
};
</script>



